import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { NetworkStatusBanner } from '@/components/common/NetworkStatusBanner';

export const Route = createRootRoute({
  component: () => (
    <TooltipProvider delay={0}>
      <NetworkStatusBanner />
      <Outlet />
      <Toaster />
    </TooltipProvider>
  ),
});
